import {BaseFlowStep} from "./BaseFlowStep.jsx";
import {Router} from "../../../../stem-core/ui/Router.jsx";
import {INLINE_SHOP_URLS} from "../../PanelConstants.js";
import {Product} from "../../../../client/state/ProductStore.js";
import {filterStoreByMerchantAndLooseIdArray} from "../../../../client/state/misc/Filter.js";

export class ProductListFlowStep extends BaseFlowStep {
    declare selectedValue: Product;
    // Snapshotted off iFrameState when the step is initialized
    declare iframeParams: any;
    getProducts() {
        const {products} = this.iframeParams;
        const productObjects = Product.all();
        if (!products) {
            return productObjects;
        }
        return filterStoreByMerchantAndLooseIdArray(productObjects, products, (obj, idOrAlias) => obj.id == idOrAlias || obj.alias == idOrAlias);
    }

    showPanel() {
        Router.changeURL(INLINE_SHOP_URLS.products);
    }
}
